const setAttributes = (element, attributes) => {
	for (const key in attributes) {
		if (attributes && element) {
			element.setAttribute(key, attributes[key]);
		}
	}
};

export default setAttributes;
